import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['dialog', 'dialogContent'];

  dialogClickHandler(e) {
    if (!this.dialogContentTarget.contains(e.target)) {
      this.closeDialog();
    }
  }

  openDialog() {
    this.dialogTarget.classList.remove('hidden');
  }

  closeDialog() {
    this.dialogTarget.classList.add('hidden');
  }
}
